import * as React from "react";
import { observer } from "mobx-react";

@observer
export class EventTime extends React.Component<{ time: string }, {}> {

    render() {
        return (
            <span className="rj-sports-multiview__event-time">{this.props.time}</span>
        )
    }
}